import { APIActions, Box, Button, CustomDialog, SuccessStateInfo, Typography } from 'web-library';
import IconWithLabel from 'web-library/stories/atom/IconWithLabel/IconWithLabel';
import { useTheme } from '@mui/material';
import { IconName } from 'web-library/stories/atom/Icon/Icon';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useQueryClient } from 'react-query';
import { IStylingAndTranslationHooks } from './model';
import { usePutRemoveExamRegistration } from '../../../../api-refactored/group-exam-registration/usePutRemoveExamRegistration';
import { GET_GROUP_EXAM_REGISTRATION_SUMMARY_QUERY_KEY } from '../../../../constants/queryKeys';

interface IStartFileProcessingSuccessActionLabel extends IStylingAndTranslationHooks {
  resetUploadAndProcessingApi: () => void;
}

const StartFileProcessingSuccessVisualLabel = ({
  classes,
  translation: t,
}: IStylingAndTranslationHooks) => (
  <Box className={classes.uploadErrorSection}>
    <SuccessStateInfo>
      <Typography
        id="text-upload-success-description"
        variant="body1"
        className={classes.uploadErrorDescription}
      >
        {t('exam->>UploadExcelTemplate.UploadSuccessDescription')}
      </Typography>
    </SuccessStateInfo>
  </Box>
);

const StartFileProcessingSuccessActionLabel = ({
  classes,
  translation: t,
  resetUploadAndProcessingApi,
}: IStartFileProcessingSuccessActionLabel) => {
  const theme = useTheme();

  const { uuid: applicationUuid } = useParams<any>();
  const queryClient = useQueryClient();
  const [isReuploadModalOpen, setIsReuploadModalOpen] = useState(false);
  const [popupErrorMessage, setPopupErrorMessage] = useState<string>('');
  const {
    mutate: putRemoveExamRegistrationMutateFn,
    status: putRemoveExamRegistrationStatus,
  } = usePutRemoveExamRegistration({
    onSuccess: () => {
      setIsReuploadModalOpen(false);
      resetUploadAndProcessingApi();
      queryClient.invalidateQueries([
        GET_GROUP_EXAM_REGISTRATION_SUMMARY_QUERY_KEY,
        applicationUuid,
      ]);
    },
    onError: (error) => {
      if (error.response?.data?.code === '2010') {
        setPopupErrorMessage(t('exam->>UploadExcelTemplate.PendingPaymentForCompletion'));
      }
    },
  });

  const reuploadClickHandler = () => {
    setIsReuploadModalOpen(true);
  };
  return (
    <Box>
      <CustomDialog
        open={isReuploadModalOpen}
        title={t('exam->>UploadExcelTemplate.ReuploadFileTitle')}
        message={
          <>
            {t('exam->>UploadExcelTemplate.ReuploadFileSubtitle')}
            <Typography style={{ color: theme.color.state.stateError }} variant="body2">
              {popupErrorMessage}
            </Typography>
          </>
        }
        action={
          <APIActions
            onClose={() => setIsReuploadModalOpen(false)}
            apiCall={() => {
              putRemoveExamRegistrationMutateFn({ uuid: applicationUuid });
            }}
            apiStatus={putRemoveExamRegistrationStatus}
            cancelString={t('exam->>UploadExcelTemplate.Cancel')}
            apiString={t('exam->>UploadExcelTemplate.Proceed')}
          />
        }
      />
      <Button id="button-re-upload" variant="text" onClick={reuploadClickHandler} color="primary">
        <IconWithLabel
          iconName={IconName.export}
          iconSize="M"
          label={t('exam->>UploadExcelTemplate.ReUploadFileDescription')}
          typographyProps={{
            variant: 'h5',
            color: 'inherit',
          }}
        />
      </Button>
    </Box>
  );
};

export { StartFileProcessingSuccessVisualLabel, StartFileProcessingSuccessActionLabel };
